module.exports = __webpack_public_path__ + "img/sport_tv_1a.d713eefb.png";